'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var jingcaizhibo = function jingcaizhibo() {
  return import('@/page/jingcaizhibo');
};
var jingcaizhiboList = function jingcaizhiboList() {
  return import('@/page/jingcaizhibo/tab.vue');
};
var broadcastReplay = function broadcastReplay() {
  return import('@/page/broadcast-replay');
};
exports.default = [{
  path: '/jingcaizhibo',
  name: 'jingcaizhibo',
  component: jingcaizhibo,
  children: [{
    path: 'jingcaizhibo-list',
    name: 'jingcaizhibo-list',
    component: jingcaizhiboList
  }, {
    path: 'broadcastReplay',
    name: 'broadcastReplay',
    component: broadcastReplay
  }]
}];